/**
 * 车队管理
 * @author xingzb
 * @date 2020-1-7
 *
 */
import request from "@/utils/request";
import requestGetError from "@/utils/requestGetError";

// 获取 商户列表
export function MerchantNanagement(query) {
  return request({
    url: "/ntocc-tms-api/mybankMerchant",
    method: "get",
    params: query
  });
}

// 新增 商户
export function addNewBusinesses(query) {
  return request({
    url: "/ntocc-tms-api/mybankMerchant",
    method: "post",
    data: query
  });
}

// 删除商户
export function deleteBankMerchant(data) {
  return request({
    url: "/ntocc-tms-api/mybankMerchant",
    method: "delete",
    params: {
      codes: data
    }
  });
}

// 编辑详情
export function mybankMerchantDetails(code) {
  return request({
    url: `/ntocc-tms-api/mybankMerchant/${code}`,
    method: "get"
  });
}

// 更新
export function merchantRegisterResult(code) {
  return request({
    url: `/ntocc-tms-api/mybankMerchant/merchantRegisterResult/${code}`,
    method: "get"
  });
}

// 编辑
export function editBankMerchant(data) {
  return request({
    url: "/ntocc-tms-api/mybankMerchant",
    method: "put",
    data
  });
}

// 省
export function bigAreaProvince(query) {
  return request({
    url: "/ntocc-basic-api/areaProvince",
    method: "get",
    params: query
  });
}

// 市
export function bigAreaCity(query) {
  return request({
    url: "/ntocc-basic-api/areaCity",
    method: "get",
    params: query
  });
}

// 县
export function bigAreaCounty(query) {
  return request({
    url: "/ntocc-basic-api/areaCounty",
    method: "get",
    params: query
  });
}

// 查询用户
export function selectParty(query) {
  return request({
    url: "/ntocc-basic-api/party",
    method: "get",
    params: query
  });
}

// 编辑详情
export function driverPartyCode(code, partyType) {
  if (partyType == "DRIVER" || partyType == "DRIVER_LEADER") {
    return request({
      url: `/ntocc-basic-api/driver/partyCode/${code}`,
      method: "get"
    });
  } else {
    return request({
      url: `/ntocc-basic-api/shipment/partyCode/${code}`,
      method: "get"
    });
  }
}

// 新增 商户
export function mybankBalancePay(query) {
  return request({
    url: "/ntocc-tms-api/mybankBalancePay",
    method: "post",
    data: query
  });
}

// 银行支付获取验证码
export function sendCentralCode(query) {
  return request({
    url: "/ntocc-tps-api/sms/sendCentralPaymentVerificationCode",
    method: "post",
    params: query
  });
}
// 银行支付打款
export function centralPayment(query) {
  return request({
    url: "/ntocc-tms-api/centralizedPayment/centralPayment",
    method: "post",
    data: query
  });
}
// 批量银行支付打款
export function batchCentralPayment(query) {
  return request({
    url: "/ntocc-tms-api/centralizedPayment/batchCentralPayment",
    method: "post",
    data: query
  });
}
// 批量托运人打款 中台打款
export function shipperPaymentSure(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/shipperPaymentSure",
    method: "post",
    params: query
  });
}
// 批量托运人打款
export function applicationForPayment(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/applicationForPayment",
    method: "post",
    params: query
  });
}

export function applicationForReturn(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/applicationForReturn",
    method: "post",
    params: query
  });
}

// 批量打款未支付
export function noFeeForPayment(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/noFeeForPayment",
    method: "post",
    params: query
  });
}

// 余额支付
export function getBalancePay(query) {
  return request({
    url: "/ntocc-tms-api/mybankBalancePay",
    method: "get",
    params: query
  });
}

export function getAccountName(query) {
  return request({
    url: "/ntocc-basic-api/shipmentServiceFee/getAccountName",
    method: "get",
    params: query
  });
}

// 支付状态查询
export function balancePayQuery(orderNos) {
  return requestGetError({
    url: "/ntocc-tms-api/mybankBalancePay/balancePayQuery",
    method: "post",
    params: {
      orderNos: orderNos
    }
  });
}

// 网商余额支付失败后再次获取验证码
export function obtainBalancePay(data) {
  return request({
    url: "/ntocc-tms-api/mybankBalancePay",
    method: "put",
    params: data
  });
}

// 网商余额支付，查询支付失败后再次获取验证码进行确认
export function obtainPayConfirmAgain(data) {
  return request({
    url: "/ntocc-tms-api/mybankBalancePay/balancePayConfirmAgain",
    method: "put",
    params: data
  });
}

// 网商预付申请提交--获取验证码
export function obtainPrepayApply(data) {
  return request({
    url: "/ntocc-tms-api/mybankPrepay/prepayApply",
    method: "put",
    params: data
  });
}

// 网商预付申请确认
export function obtainPrepayConfirm(data) {
  return request({
    url: "/ntocc-tms-api/mybankPrepay/prepayConfirm",
    method: "put",
    data
  });
}

// 网商预付单表
export function getBankPrepay(query) {
  return request({
    url: "/ntocc-tms-api/mybankPrepay",
    method: "get",
    params: query
  });
}

// 网商预付申请确认
export function obtainPrepayQuery(data) {
  return request({
    url: "/ntocc-tms-api/mybankPrepay/prepayQuery",
    method: "put",
    data
  });
}

// 网商预付申请提交--失败后，重新提交获取验证码
export function obtainPrepayApplyAgain(data) {
  return request({
    url: "/ntocc-tms-api/mybankPrepay/prepayApplyAgain",
    method: "put",
    params: data
  });
}

// 网商预付申请确认-失败后重新获取验证码后的确认
export function obtainPrepayConfirmAgain(data) {
  return request({
    url: "/ntocc-tms-api/mybankPrepay/prepayConfirmAgain",
    method: "put",
    params: data
  });
}

// 网商预付申请确认-网商预付推进
export function obtainPrepayPush(data) {
  return requestGetError({
    url: "/ntocc-tms-api/mybankPrepay/prepayPush",
    method: "put",
    params: {
      orderDetailCodes: data
    }
  });
}

// 网商预付推进
export function getPrepayPushList(query) {
  return request({
    url: "/ntocc-tms-api/mybankPrepay/mybankPrepayPushList",
    method: "get",
    params: query
  });
}

// 网商预付推进查询
export function obtainPrepayPushQuery(orderNos) {
  return requestGetError({
    url: "/ntocc-tms-api/mybankPrepay/prepayPushQuery",
    method: "put",
    params: {
      orderNos: orderNos
    }
  });
}
// 网商预付推进查询单条-结果即时返回
export function obtainPrepayPushOneQuery(orderNo) {
  return requestGetError({
    url: "/ntocc-tms-api/mybankPrepay/prepayPushQuery/" + orderNo,
    method: "put"
  });
}
// 网商预付推进失败后再次推进
export function obtainPrepayPushAgain(orderNo) {
  return request({
    url: "/ntocc-tms-api/mybankPrepay/prepayPushAgain",
    method: "put",
    params: {
      orderNo: orderNo
    }
  });
}

// 获取 网商提现表 列表
export function getBankWithdraw(query) {
  return request({
    url: "/ntocc-tms-api/mybankWithdraw",
    method: "get",
    params: query
  });
}

// 网商提现查询
export function obtainWithdrawQuery(data) {
  return requestGetError({
    url: "/ntocc-tms-api/mybankWithdraw/withdrawQuery",
    method: "put",
    params: {
      code: data
    }
  });
}

// 获取默认银行卡
export function bankCardPartyCode(code) {
  return request({
    url: `/ntocc-basic-api/bankCard/partyCode/${code}/mybankRegister`,
    method: "get"
  });
}

// 查询余额
export function queryBalance(code) {
  return request({
    url: `/ntocc-tms-api/mybankMerchant/queryBalance/${code}`,
    method: "get"
  });
}

export function depositInquiry(data) {
  return request({
    url: `/ntocc-tms-api/mybankVostroChargeBatchQuery`,
    method: "get",
    params: data
  });
}

// 查询钱包
export function accountInfo(merchantId, acctType) {
  return request({
    url: `/ntocc-tms-api/mybankAccount/accountInfo/${merchantId}/${acctType}`,
    method: "get"
  });
}

// 查询余额
export function registerMerchant(code) {
  return request({
    url: `/ntocc-tms-api/mybankMerchant/registerMerchant/${code}`,
    method: "get"
  });
}

// 提现审核
export function withdrawAudit(data) {
  return request({
    url: "/ntocc-tms-api/mybankWithdraw/withdrawAudit",
    method: "put",
    params: data
  });
}

// 分账申请
export function orderShareApply(data) {
  return requestGetError({
    url: "/ntocc-tms-api/mybankOrderShare/orderShareApply",
    method: "post",
    data: data
  });
}

// 分账列表
export function mybankOrderShare(query) {
  return request({
    url: "/ntocc-tms-api/mybankOrderShare",
    method: "get",
    params: query
  });
}

// 更新分账结果
export function orderShareQuery(relateOrderNo) {
  return requestGetError({
    url: "/ntocc-tms-api/mybankOrderShare/orderShareQuery",
    method: "get",
    params: {
      relateOrderNo: relateOrderNo
    }
  });
}

// 开通余额支付功能
export function openBalancePay(code) {
  return request({
    url: `/ntocc-tms-api/mybankMerchant/openBalancePay/${code}`,
    method: "get"
  });
}

// 开通商户子户
export function createAccount(type, code) {
  return request({
    url: `/ntocc-tms-api/mybankAccount/createAccount/${type}/${code}`,
    method: "get"
  });
}

// 获取详情
export function mybankKybDetail(merchantId) {
  return request({
    url: `/ntocc-tms-api/mybankKyb/${merchantId}`,
    method: "get"
  });
}

// 打款申请
export function payApplication(query) {
  return request({
    url: "/ntocc-tms-api/mybankKyb",
    method: "post",
    data: query
  });
}

// 打款验证
export function payCheck(query) {
  return request({
    url: `/ntocc-tms-api/mybankKyb/kybMatch`,
    method: "post",
    data: query
  });
}

// 网商电子回单
export function mybankElectronicReceipt(params, method) {
  return request({
    url: "/ntocc-tms-api/mybankElectronicReceipt",
    method: method,
    params: params
  });
}

export function transferMoney(data) {
  return request({
    url: "/ntocc-basic-api/shipmentServiceFee/transferMoney",
    method: "post",
    data
  });
}

// 网商支付 批量申请
export function applyMultiBatch(data) {
  return request({
    url: "/ntocc-tms-api/mybankElectronicReceipt/applyBatch",
    method: "post",
    data
  });
}

// 凭证支付 批量申请
export function getIssueTransferFileBatch(params) {
  return request({
    url: "/ntocc-tms-api/maYiCreditFlow/getIssueTransferFileBatch",
    method: "post",
    params
  });
}

// 下载电子回单
export function downLoadFile(params) {
  return request({
    url: "/ntocc-tms-api/mybankElectronicReceipt/downLoadFile",
    method: "get",
    params: params
  });
}

// 凭证支付下载电子回单
export function downLoadCredit(params) {
  return request({
    url: "ntocc-tms-api/creditProof/downLoadCreditProofPdfZip",
    method: "get",
    params: params
  });
}

// 网商电子回单
export function mybankElectronicReceiptInfo(orderNo) {
  return request({
    url: `/ntocc-tms-api/mybankElectronicReceipt/${orderNo}`,
    method: "get"
  });
}
// 申请网商回单
export function batchApply(query) {
  return request({
    url: "/ntocc-tms-api/mybankElectronicReceipt/batchApply",
    method: "post",
    params: query
  });
}
// 电子回单详情
export function electronicReceipt(query) {
  return request({
    url: "/ntocc-tms-api/centralizedPayment/downLoadElectronicReceipt",
    method: "get",
    params: query
  });
}
// 获取流水号
export function queryReceiptNo(query) {
  return request({
    url: "/ntocc-tms-api/centralizedPayment/queryReceiptNo",
    method: "put",
    params: query
  });
}
//
export function electronicReceiptQuery(receiptNo) {
  return request({
    url: `/ntocc-tms-api/mybankElectronicReceipt/electronicReceiptQuery`,
    method: "post",
    params: {
      receiptNo: receiptNo
    }
  });
}
// 线下授权 /mybankMerchantprodMerch/signOffline
export function signOffline(data) {
  return request({
    url: "/ntocc-tms-api/mybankMerchantprodMerch/signOffline",
    method: "put",
    params: data
  });
}

//  线下授权 /mybankMerchantprodMerch/signOffline
export function updateMerchSignQuery(data) {
  return request({
    url: "/ntocc-tms-api/mybankMerchantprodMerch/merchantprodMerchSignQuery",
    method: "put",
    params: data
  });
}
export function getprodMerchRecord(query) {
  return request({
    url: `/ntocc-tms-api/mybankMerchantprodMerch`,
    method: "get",
    params: query
  });
}
// 获取司机授权管理
export function driverMerchantList(query) {
  return request({
    url: "/ntocc-tms-api/mybankMerchantprodMerch/driverMerchantList",
    method: "get",
    params: query
  });
}

// 获取托运人授权管理
export function shipmentMerchantList(query) {
  return request({
    url: "/ntocc-tms-api/mybankMerchantprodMerch/shipmentMerchantList",
    method: "get",
    params: query
  });
}

export function getprodMerchRecordShipmentList(query) {
  return request({
    url: `/ntocc-tms-api/mybankMerchantprodMerch/shipmentList`,
    method: "get",
    params: query
  });
}

// 获取 来张汇入通知列表
export function getMybankVostroNotify(query) {
  return request({
    url: "/ntocc-tms-api/mybankVostroNotify",
    method: "get",
    params: query
  });
}

// 获取 平台信用流转是否足额
export function getMayiCreditBalance(query) {
  return request({
    url: "/ntocc-tms-api/maYiCreditFlow/queryCreditBalance",
    method: "post",
    params: query
  });
}

// new 网商提现短信接口
export function sendWithdrawCode(data) {
  return request({
    url: "/ntocc-tps-api/sms/sendWithdrawCode",
    method: "post",
    params: data
  });
}
// new 网商余额提现
export function withdrawPlatform(data) {
  return request({
    url: "/ntocc-tms-api/mybankWithdraw/withdrawPlatform",
    method: "put",
    params: data
  });
}
// new 网商保证金提现-托运人
export function createRefund(data) {
  return request({
    url: "/ntocc-tms-api/mybankCashDepositRefund/createRefund",
    method: "post",
    params: data
  });
}
// new 网商保证金提现-平台
export function refundApply(data) {
  return request({
    url: "/ntocc-tms-api/mybankCashDepositRefund/refundApply",
    method: "put",
    params: data
  });
}
// 电子回单二期功能 获取列表
export function arpaTransferTwo(query) {
  return request({
    url: "/ntocc-tms-api/arpaTransfer",
    method: "get",
    params: query
  });
}
// 云起付二期 获取列表
export function getArpaWithdraw(query) {
  return request({
    url: "/ntocc-tms-api/arpaWithdraw",
    method: "get",
    params: query
  });
}
// 提现审核 驳回记录
export function arpaWithdraw(query) {
  return requestGetError({
    url: "/ntocc-tms-api/arpaWithdraw",
    method: "put",
    params: query
  });
}
// 更新列表
export function updateWithdraw(query) {
  return requestGetError({
    url: "/ntocc-tms-api/arpaWithdraw/queryWithdraw",
    method: "put",
    params: query
  });
}
// 查看回单
export function lookReceiptTwo(query) {
  return request({
    url: "/ntocc-tms-api/arpaTransfer/receipt",
    method: "get",
    params: query
  });
}
// 托运人打款获取验证码
export function shipmentBalancePaySendSmsCode(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/shipmentBalancePaySendSmsCode",
    method: "post",
    params: query
  });
}

// 批量更新托运人打款支付状态
export function queryShipperPaymentResult(query) {
  return request({
    url: "/ntocc-tms-api/arpaTransfer/queryShipperPaymentResult",
    method: "post",
    params: query
  });
}

// 返回预付支付金额
export function preApplicationForPrepay(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/preApplicationForPrepay",
    method: "post",
    params: query
  });
}

export function isexistPSW(query) {
  return request({
    url: "/ntocc-basic-api/pay/isexist",
    method: "get",
    params: query
  });
}

// 校验支付密码是否正确
export function verifyPay(data) {
  return request({
    url: "/ntocc-basic-api/pay/verify",
    method: "post",
    data: data
  });
}

// 预付款接口
export function applicationForPrepay(query) {
  return request({
    url: "/ntocc-tms-api/orderDetail/applicationForPrepay",
    method: "post",
    params: query
  });
}
